// Attachment images need the bearer token (GET /blobs → 302 → R2), so <img> gets an object URL fetched once
// per blob url and kept for the session: a card remounted in another column shows its cover without a refetch.
import { useEffect, useState } from "react";
import { api } from "@/api";

const cache = new Map<string, Promise<string>>();
const ready = new Map<string, string>();

export function blobUrl(url: string): Promise<string> {
	const direct = api.blobs.direct?.(url);
	if (direct) return Promise.resolve(direct);
	let p = cache.get(url);
	if (!p) {
		p = api.blobs.open(url).then((u) => {
			ready.set(url, u);
			return u;
		});
		p.catch(() => cache.delete(url));
		cache.set(url, p);
	}
	return p;
}

/** Object URL for a `blob://` url (null while loading or on error). */
export function useBlobUrl(url: string | null | undefined): string | null {
	const [src, setSrc] = useState(() => (url ? (api.blobs.direct?.(url) ?? ready.get(url) ?? null) : null));
	useEffect(() => {
		if (!url) return setSrc(null);
		let live = true;
		blobUrl(url).then(
			(u) => live && setSrc(u),
			() => live && setSrc(null),
		);
		return () => {
			live = false;
		};
	}, [url]);
	return url ? src : null;
}
